import React from 'react';
import {Stack} from '@mui/material';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import EmptyState from './EmptyState';
import {REPORT_TABLE_COLUMNS} from '../../constants/tableColumns';

/**
 * Reports table component
 * @param {Array} reports - Array of report data
 * @param {boolean} loading - Loading state
 * @param {Array} columns - Column configurations (optional, defaults to REPORT_TABLE_COLUMNS)
 * @param {boolean} enableDisclosureCreation - Whether to enable disclosure creation (for Fintel reports)
 * @param {function} onRowChanged - Called after a row action mutates data (delete / reset) so the list can refresh
 */
const ReportsTable = ({
                          reports = [],
                          loading = false,
                          columns = REPORT_TABLE_COLUMNS,
                          enableDisclosureCreation = false,
                          onRowChanged
                      }) => {
    const hasReports = reports && reports.length > 0;

    return (
        <Stack
            borderRadius={1}
            border="1px solid #e0e0e0"
            bgcolor="#e0e0e0"
            spacing="1px"
        >
            <TableHeader columns={columns}/>

            {loading || !hasReports ? (
                <EmptyState loading={loading} reportCount={reports?.length || 0}/>
            ) : (
                reports.map((report, index) => (
                    <TableRow
                        key={report.id || index}
                        report={report}
                        columns={columns}
                        enableDisclosureCreation={enableDisclosureCreation}
                        onRowChanged={onRowChanged}
                    />
                ))
            )}
        </Stack>
    );
};

export default ReportsTable;
